import { ENDPOINTS, getApiUrl, Requests } from "@/common";
import { INotificationListResponse } from "@/common/types/notification";

export const getNotifications = async (page = 1, limit = 20): Promise<INotificationListResponse> => {
  const apiUrl = getApiUrl(ENDPOINTS.GET_NOTIFICATIONS, { page, limit });
  return Requests.get(apiUrl);
};

export const getUnreadCount = async (): Promise<{ count: number }> => {
  const apiUrl = getApiUrl(ENDPOINTS.GET_NOTIFICATIONS_UNREAD_COUNT);
  return Requests.get(apiUrl);
};

export const markNotificationAsRead = async (id: string): Promise<{ success: boolean }> => {
  const apiUrl = getApiUrl(ENDPOINTS.MARK_NOTIFICATION_READ, { id }, true);
  return Requests.patch(apiUrl, {});
};

export const markAllNotificationsAsRead = async (): Promise<{ success: boolean }> => {
  const apiUrl = getApiUrl(ENDPOINTS.MARK_ALL_NOTIFICATIONS_READ);
  return Requests.patch(apiUrl, {});
};

export const deleteNotification = async (id: string): Promise<{ success: boolean }> => {
  const apiUrl = getApiUrl(ENDPOINTS.DELETE_NOTIFICATION, { id }, true);
  return Requests.delete(apiUrl);
};
